// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1581":"86ff5edf","7627":"87ac39f5"}[chunkId] + ".chunk.css";
};